import { useMemo } from 'react';

import { appSettings, WEBSITE_SETTINGS } from '@env';
import { IBuildAppSettings } from '@model';
import { isDevEnv } from '@utils/development';

import { ECountryLocale, ILocalHostStartUpAppSettings } from '../../../config';

export const useLoadApplicationSettings = (): IBuildAppSettings => {
  const {
    cdnBaseUrlAddress,
    checkoutGatewayBaseUrlAddress,
    applicationName,
    environment,
    przelewyPaymentAddress,
    googleApiKey,
    mapyCzApiKey,
    newRelicLicenseKey,
    newRelicAppId,
    newRelicAccountId,
  } = appSettings;
  let websiteHostAddress = location.origin;
  let checkoutGatewayUri = `${websiteHostAddress}/${checkoutGatewayBaseUrlAddress}`;
  const { locale, domainName } =
    WEBSITE_SETTINGS.find((site) => site.hostname === location.hostname) ??
    WEBSITE_SETTINGS.find((site) => site.locale === ECountryLocale.UNDEFINED)!;

  if (isDevEnv()) {
    checkoutGatewayUri = checkoutGatewayBaseUrlAddress;
    websiteHostAddress = (appSettings as ILocalHostStartUpAppSettings).websiteHostAddress;
  }

  return useMemo(() => {
    return {
      cdnBaseUrlAddress,
      checkoutGatewayBaseUrlAddress: checkoutGatewayUri,
      websiteHostAddress,
      applicationName,
      locale,
      domainName,
      environment,
      przelewyPaymentAddress,
      googleApiKey,
      mapyCzApiKey,
      newRelicLicenseKey,
      newRelicAppId,
      newRelicAccountId,
    };
  }, [
    cdnBaseUrlAddress,
    checkoutGatewayUri,
    websiteHostAddress,
    applicationName,
    locale,
    domainName,
    environment,
    przelewyPaymentAddress,
    googleApiKey,
    mapyCzApiKey,
    newRelicLicenseKey,
    newRelicAppId,
    newRelicAccountId,
  ]);
};
